import { TableauUser } from '@tableau/data-catalog-client-components';

import { IIdItemInfo } from '../../spacesPlatform/models/resourceInfoParts';

/**
 * The owner/author of a data quality indicator. Since user info can be "hidden", all these fields
 * may be null.
 *
 * Note: in some other parts of VizPortal Client (e.g. data source owner and certifier), a hidden user
 * is represented as a null user object. Here (from the dataQualityIndicators field in the
 * getDatasource/getDatasources API response), a hidden user is represented by an owner object with null fields;
 * this matches the TableauUser interface in DC3 as well as the way the Data Catalog GraphQL API
 * returns hidden users.
 */
export type DataQualityOwner = {
  username: string | null;
  displayName: string | null;
  domainName?: string | null;
};

export interface IDataQualityIndicatorInfo extends IIdItemInfo {
  isActive: boolean;
  isSevere: boolean;
  type: string;
  message: string;
  updatedAt?: Date;
  owner: DataQualityOwner;
}

export function dataQualityOwnerToTableauUser(owner: DataQualityOwner | null | undefined): TableauUser {
  if (!owner) {
    return { username: null, domain: null, name: null };
  }

  return {
    username: owner.username || null,
    name: owner.displayName || null,
    domain: owner.domainName || null,
  };
}

export function dataQualityIndicatorInfoToDataQualityIndicator(indicator: IDataQualityIndicatorInfo): IDataQualityIndicatorDefinedInVizportalWebclientApi {
  const { owner, ...rest } = indicator;
  const user = dataQualityOwnerToTableauUser(owner);

  return {
    ...rest,
    owner: {
      domain: user.domain,
      domainName: user.domain,
      username: user.username,
      displayName: user.name,
      authId: '',
      id: '',
    }
  };
}

type IDataQualityIndicatorDefinedInVizportalWebclientApi = {
  id: string;
  isActive: boolean;
  isSevere: boolean;
  type: string;
  message: string;
  updatedAt?: Date;
  owner: {
    id: string;
    authId: string;
    displayName: string;
    username: string;
    domain: string;
    domainName: string;
  };
}
